var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[(_vm.$store.getters.isIE)?_c('IeMessage'):_c('router-view'),(_vm.$store.getters.getModalOpen && !_vm.$store.getters.isIE)?_c('ModalProduct'):_vm._e(),(_vm.$store.getters.getGlobalLoading && !_vm.$store.getters.isIE)?_c('TheLoader'):_vm._e(),(_vm.showSetupModal)?_c('ShoppingSetupModal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }